module.exports = __webpack_public_path__ + "img/PHED.21c60a4d.svg";